import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    window.dataLayer = window.dataLayer || [];
    this.triggered25 = false;
  }

  addListeners() {
    this.el.addEventListener('click', this.handleClick.bind(this));
    document
      .querySelector('.navigation-v2__container')
      .addEventListener('scroll', this.handleScroll.bind(this));
  }

  primaryMenuEvent() {
    const gtmEventName = 'primary_navigation_menu';

    if (this.el.hasAttribute('data-menu-category')) {
      return this.pushDataLayer({
        event: gtmEventName,
        click_text: this.getDataset('name'),
        menu_category: this.getDataset('menuCategory')
      });
    }

    return this.pushDataLayer({
      event: gtmEventName,
      click_text: this.getDataset('name')
    });
  }

  homeInsightCardEvent() {
    this.pushDataLayer({
      event: 'insights_cards_click',
      click_text: this.getDataset('name')
    });
  }

  getPercentage(partialValue, totalValue) {
    return (100 * partialValue) / totalValue;
  }

  getDataset(name) {
    return this.el.dataset[name];
  }

  pushDataLayer(data) {
    window.dataLayer.push(data);
  }

  getScrollPercentage(event) {
    const scrollTop = event.target.scrollTop;
    const fixedHeight = event.target.scrollHeight - event.target.clientHeight;
    const scrollPercentage =
      Math.round(
        (this.getPercentage(scrollTop, fixedHeight) + Number.EPSILON) * 100
      ) / 100;
    return scrollPercentage;
  }

  hasValueDeep(json, findValue) {
    const values = Object.values(json);
    let hasValue = values.includes(findValue);
    values.forEach(value => {
      if (typeof value === 'object') {
        hasValue = hasValue || this.hasValueDeep(value, findValue);
      }
    });
    return hasValue;
  }

  handleScroll(event) {
    const pushScrollEvent = percentage => {
      if (this.hasValueDeep(window.dataLayer, percentage)) return;
      this.pushDataLayer({
        event: 'menu_scroll_percentage',
        menu_scroll_percentage: percentage
      });
    };

    if (
      this.getScrollPercentage(event) >= 25 &&
      this.getScrollPercentage(event) < 50
    ) {
      return pushScrollEvent('25%');
    }

    if (
      this.getScrollPercentage(event) >= 50 &&
      this.getScrollPercentage(event) < 75
    ) {
      return pushScrollEvent('50%');
    }

    if (
      this.getScrollPercentage(event) >= 75 &&
      this.getScrollPercentage(event) < 100
    ) {
      return pushScrollEvent('75%');
    }

    if (this.getScrollPercentage(event) === 100) {
      return pushScrollEvent('100%');
    }
  }

  handleClick(event) {
    const { target } = event;

    const navigation = target.closest('.navigation-v2');
    const mobileNavigation = target.closest('.mobile-navigation-v2');
    if (navigation || mobileNavigation) {
      return this.primaryMenuEvent();
    }

    const homeInsightCard = target.closest('.insight-card-v2');
    if (homeInsightCard) {
      return this.homeInsightCardEvent();
    }
  }
}

export default Module;
